import React, { useEffect, useState } from "react";
import "./aboutus.css";
import { getDatabase, ref, onValue, set } from "firebase/database";

function Aboutus() {
let [lawyerLength,setlawyerLength] =useState('')
let [casesLength,setcasesLength] =useState('')
let [coustomerLength,setcoustomerLength] =useState('')

useEffect(()=>{
  const db = getDatabase();
    const starCountRef = ref(db, "/lawyer");
    onValue(starCountRef, (snapshot) => {
      let arr = [];
      snapshot.forEach((element) => {
        if(element.val().approved== "yes"){

          arr.push(element.val());
        }
        console.log();
      });

      setlawyerLength(arr.length)
      // setLawyersarr(arr);
    });



    const starCountRef2 = ref(db, "/requests");
    onValue(starCountRef2, (snapshot) => {
      let arr = [];
      snapshot.forEach((element) => {
        if(element.val().response == "no" && (element.val().approved =='Approved' || element.val().approved =='Not Approved')){

          arr.push(element.val());
        }
      });

      setcasesLength(arr.length)
      // setLawyersarr(arr);
    });



    const starCountRef1 = ref(db, "/Client");
    onValue(starCountRef1, (snapshot) => {
      let arr = [];
      snapshot.forEach((element) => {
        // if(element.val().approved== "yes"){

          arr.push(element.val());
        // }
       
      });

      setcoustomerLength(arr.length)
      // setLawyersarr(arr);
    });
},[])


  return (
    <>
      <div className="container">
        <h1 className="other">
          IN TECHNICAL SENSE LAWYERS ONLINE MAY BE TERMED AS A PORTAL AND BEING
          A LAW PORTAL, IT OFFERS THE BASIC FUNCTIONALITIES OF A WEB PORTAL
          WHICH ENCOMPASS SEARCHING OF LAWS, CASE LAWS, AND NOTIFICATIONS AS
          WELL AS FINDING LAWYERS IN FAISALABAD.
        </h1>
        <p className="abtpara">
          The website is generic to some extent, Yet it is specific to law and
          law industry. Legal resources for Lawyers, Advocates, Judges,
          Businessmen, Students and other legal professionals at one place.
          Legal resources at Lawyers Online includes, statues (Acts, Rules,
          Ordinances etc.) Search facilities, sent email and other related
          information therefore, this site after its hosting on web attracted
          the attention of the surfers, web users by getting such advantage. The
          Lawyers Online successfully aiming its goal by spreading legal
          knowledge in society and promoting the law culture in society as well.
        </p>
      </div>
      <section id="counts" class="counts section-bg">
        <div class="container">
          <div class="row counters">
            <div class="col l4 col-6 text-center">
              {" "}
              <span
                data-purecounter-start="0"
                data-purecounter-end="10"
                data-purecounter-duration="0"
                class="purecounter"
              >
               {coustomerLength}
              </span>
              <p>Users</p>
            </div>
            <div class="col l4 col-6 text-center">
              {" "}
              <span
                data-purecounter-start="0"
                data-purecounter-end="5"
                data-purecounter-duration="0"
                class="purecounter"
              >
                {casesLength}
              </span>
              <p>Cases</p>
            </div>
            <div class="col l4 col-6 text-center">
              {" "}
              <span
                data-purecounter-start="0"
                data-purecounter-end="2"
                data-purecounter-duration="0"
                class="purecounter"
              >
                {lawyerLength}
              </span>
              <p>Lawyers</p>
            </div>
          </div>
        </div>
      </section>
      {/* <div className="container">
        <div className="row">
          <div className="col m3">
            <img className="img1" src="one.png" alt="" />
            <h2 className="team-name">Imran Butt</h2>
            <strong className="team-desc">senior lawyer</strong>
          </div>
          <div className="col m3">
            <img className="img1" src="two.jpg" alt="" />
            <h2 className="team-name">Imran Butt</h2>
            <strong className="team-desc">senior lawyer</strong>
          </div>
          <div className="col m3">
            <img className="img1" src="three.png" alt="" />
            <h2 className="team-name">Imran Butt</h2>
            <strong className="team-desc">senior lawyer</strong>
          </div>
          <div className="col m3">
            <img className="img1" src="one.png" alt="" />
            <h2 className="team-name">Imran Butt</h2>
            <strong className="team-desc">senior lawyer</strong>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default Aboutus;
